<p-confirmDialog key="stationblockalert" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="stationblockalertconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Block List</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onUpdate()">Edit Block List</button>
		<button class="btn btn-warning" style="margin-left: 5px" (click)="onToggle()">{{ ToggleText }}</button>
		<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete Block List</button>

		<img class="info-img" (click)="onShowInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="ShowInfo == true ? 'block' : 'none'">
		<label>This page lets you block students from scanning in at ScanStation</label><br />
		<label>Students won't be marked suspended but it will display a message and play an invalid scan sound</label><br />
		<label>The sound that plays can be customized for each school from the Preference Settings page under School Settings</label><br />
		<label>You can also block students during certain times of day, Ex. you can block night-school students from scanning in before a certain time</label
		><br />
		<label>NOTE: This only applies to Entry Scanning</label><br />
		<br />
		<label>&#9900; Add Block List: Create a new list of students to block</label><br />
		<label>&#9900; Update Block List: Update the message, Date Range, or Time Range</label><br />
		<label>&#9900; Toggle Block List: Deactivate the Block List so it won't be used by ScanStation</label><br />
		<label>&#9900; Delete Block List: Delete the Block List so it won't be used by ScanStation</label><br />
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstTable"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedStationBlockAlert"
		dataKey="StationBlockAlertID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--Message-->
				<th>
					<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th *ngIf="AllSchools() == true">
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DateDesc-->
				<th>
					<p-columnFilter type="text" field="DateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--TimeDesc-->
				<th>
					<p-columnFilter type="text" field="TimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PriorityDesc-->
				<th>
					<p-columnFilter field="PriorityDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPriorityDesc
								[ngModel]="value"
								[options]="lstPriorityDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--c_dateDesc-->
				<th>
					<p-columnFilter type="text" field="c_dateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentCount-->
				<th>
					<p-columnFilter type="text" field="StudentCount" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
				<th *ngIf="AllSchools() == true" pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="DateDesc">Date Range<p-sortIcon field="DateDesc"></p-sortIcon></th>
				<th pSortableColumn="TimeDesc">Time Range<p-sortIcon field="TimeDesc"></p-sortIcon></th>
				<th pSortableColumn="PriorityDesc">Priority<p-sortIcon field="PriorityDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="c_dateDesc">Last Updated<p-sortIcon field="c_dateDesc"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Student Count<p-sortIcon field="StudentCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-StationBlockAlert>
			<tr [pSelectableRow]="StationBlockAlert" (dblclick)="onDoubleClick(StationBlockAlert)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.Message }}
				</td>
				<td *ngIf="AllSchools() == true" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.SchoolName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.DateDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.TimeDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.PriorityDesc }}
				</td>
				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="StationBlockAlert.Active == true ? 'Black' : 'Red'"
				>
					{{ StationBlockAlert.ActiveDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.c_dateDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert.StudentCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
